module.exports = __webpack_public_path__ + "static/Umberto-Bondi-e4516e5803f00a964589694fa688627b.jpg";